export default __webpack_public_path__ + "static/footerbottombg-5992efe96cf50558011e3bf64e00661e.png";